import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getSubcompanies = (state) => get(state, 'subcompanies.list.entities.subcompanies', {});
export const getSubcompaniesIds = (state) =>
  get(state, 'subcompanies.list.result.subcompanies', []);
export const getIsFetching = (state) => get(state, 'subcompanies.form.isFetching', false);
export const getIsSaving = (state) => get(state, 'subcompanies.form.isSaving', false);
export const getSubcompany = (state) => get(state, 'subcompanies.form.subcompany', null);
export const getListIsFetching = (state) => get(state, 'subcompanies.list.isFetching', false);

export const getVisibleSubcompanies = createSelector(
  [getSubcompaniesIds, getSubcompanies],
  (ids, subcompanies) => ids.map((id) => subcompanies[id])
);



// WEBPACK FOOTER //
// src/modules/secured/modules/subcompanies/selectors/subcompanies_selectors.js